import styled from "styled-components";

import { Button, PrimaryButton } from "components/Button";

export const MenuContainer = styled.section<{
  fullExtend: boolean;
  marginless: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  margin-left: auto;

  ${({ fullExtend }) =>
    fullExtend &&
    `
    flex-grow: 1;
  `}

  ${({ marginless }) =>
    marginless &&
    `
    margin-left: 0;
  `}

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    margin: 0 6px 0 40px;
  }
`;

export const LoginButton = styled.a`
  line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
  width: 100%;
  padding: 10.5px 24px;
  color: ${({ theme }) => theme.customTheme.palette.black.black25};
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.customTheme.palette.black.black25};
  height: fit-content;
  border-radius: 28px;
  font-weight: 700;
  text-decoration: none;
  text-align: center;
`;

export const LogoutButton = styled(PrimaryButton)`
  padding: ${({ theme }) => theme.customTheme.pxToRem(10)} ${({ theme }) => theme.customTheme.pxToRem(24)};
  font-size: ${({ theme }) => theme.customTheme.pxToRem(18)};
  width: 100%;
  min-width: 160px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const CancelLogoutButton = styled(Button)`
  background: none;
  border: none;
  text-decoration: underline;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(22)};
  margin-top: 12px;
`;

export const LogButton = styled(Button)`
  line-height: 24px;
  font-size: 20px;
  padding: 10.5px 24px;
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
  border: none;
`;

export const TextMenuItem = styled(Button)`
  line-height: 24px;
  font-size: 20px;
  padding: 10.5px 24px;
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
  border: none;

  font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};

  ${({ theme }) => theme.customTheme.breakpoints.down("lg")} {
    padding: 10.5px 0px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(20)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(24)};
`;

export const MobileAndCartWrapper = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 1rem;
  z-index: 100;
`;

export const OpenedMenuContainer = styled.div<{
  isVisibleBySliding: boolean;
}>`
  position: fixed;
  top: -100%;
  left: 0;
  background: white;
  padding: 1rem 24px;
  width: 100vw;
  transition: 0.8s;
  ${({ isVisibleBySliding }) =>
    isVisibleBySliding &&
    `
    top: 76px;
  `}
  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    padding: 1rem 48px;
    ${({ isVisibleBySliding }) =>
      isVisibleBySliding &&
      `
      top: 63px;
    `}
  }
`;

export const VisibleWrapper = styled.div<{
  visible: boolean;
}>`
  opacity: 0;
  pointer-events: none;
  transition: 0.3s;
  ${({ visible }) =>
    visible &&
    `
    opacity: 1;
    pointer-events: auto;
  `}
`;
